export enum TrafficFunnelDefault {
  Default = 'default',
}

export enum TrafficFunnel {
  JobScout24 = 'jobscout24',
  JobScout24Free = 'JS24free',
  JobScout24Purchase = 'JS24purchase',
  JobsFree = 'jobsfree',
  JobsPurchase = 'jobspurchase',
  JobUp = 'jobup',
}

export type TrafficFunnelWithDefault = TrafficFunnel | TrafficFunnelDefault;
